var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "307px",
    height: "71px",
    viewBox: "0 0 307 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404-notfound") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.5167636,29.3604689 C81.1088447,27.1584051 82.5917695,25.1706228 84.3780228,18.4159545 C86.1642762,11.6612862 87.0478564,2.65789043 112.106318,1.25031429 C137.16478,-0.157261841 271.124112,-0.157261841 301.357952,37.4877095 C339.970211,85.5648753 -5.60200739,72.24434 0.0708949592,39.4797427 C1.12821959,33.3730245 13.0994278,34.702569 36.4727019,33.803808 C47.0995263,33.3951799 69.9246825,31.5625327 75.5167636,29.3604689 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 404,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ErrorPage2",
    transform: "translate(-567.000000, -253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "404-notfound",
    transform: "translate(567.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5167636,29.3604689 C81.1088447,27.1584051 82.5917695,25.1706228 84.3780228,18.4159545 C86.1642762,11.6612862 87.0478564,2.65789043 112.106318,1.25031429 C137.16478,-0.157261841 271.124112,-0.157261841 301.357952,37.4877095 C339.970211,85.5648753 -5.60200739,72.24434 0.0708949592,39.4797427 C1.12821959,33.3730245 13.0994278,34.702569 36.4727019,33.803808 C47.0995263,33.3951799 69.9246825,31.5625327 75.5167636,29.3604689 Z",
    id: "Path-4",
    fill: "#0193E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5167636,31.3604689 C83.1088447,29.1584051 84.5917695,27.1706228 86.3780228,20.4159545 C88.1642762,13.6612862 89.0478564,4.65789043 114.106318,3.25031429 C139.16478,1.84273816 273.124112,1.84273816 303.357952,39.4877095 C341.970211,87.5648753 -3.60200739,74.24434 2.07089496,41.4797427 C3.12821959,35.3730245 15.0994278,36.702569 38.4727019,35.803808 C49.0995263,35.3951799 71.9246825,33.5625327 77.5167636,31.3604689 Z",
    id: "Path-4",
    fill: "#43C8EC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    fill: "#43C8EC",
    cx: 24.5,
    cy: 18.5,
    rx: 10.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2-Copy",
    fill: "#43C8EC",
    cx: 45.5,
    cy: 11.5,
    rx: 4.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path-4",
    fill: "#43C8EC",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultError);
export default __webpack_public_path__ + "static/media/default-error.f246ddf367c6fbd67942e5a13382a7f1.svg";
export { ForwardRef as ReactComponent };